import { FolderRole, LibraryFolder } from '@/library/library_types.ts'

export function isFolderShared(folder: LibraryFolder): boolean {
  const activeRoles = folder.folder_roles?.filter(role => role.role !== FolderRole.NONE) || []
  return activeRoles?.length > 1
}